import { Link } from 'react-router';
import { cn } from '@/lib/cn';

/** Wordmark: a crosshair-in-frame glyph + "TestRome". */
export function Brand({ to = '/', className, compact }: { to?: string; className?: string; compact?: boolean }) {
  return (
    <Link to={to} className={cn('inline-flex items-center gap-2 rounded-[var(--radius-ctl)] text-ink', className)} aria-label="TestRome">
      <svg viewBox="0 0 24 24" className="size-6 shrink-0" aria-hidden>
        <rect x="1.5" y="1.5" width="21" height="21" rx="4" fill="var(--accent)" />
        <path d="M6.5 7h11M12 7v10.5" stroke="var(--accent-ink)" strokeWidth="2.2" strokeLinecap="round" />
        <circle cx="17" cy="16.5" r="2.3" fill="none" stroke="var(--accent-ink)" strokeWidth="1.6" />
      </svg>
      {!compact && <span className="text-[15px] font-bold tracking-[-0.02em]">TestRome</span>}
    </Link>
  );
}
